module.exports = __webpack_public_path__ + "static/ms40th_project_green-34461dfacacc9a77be8b1f1bb9d8edfc.svg";